/* eslint-disable max-lines */
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
import type * as Types from "./types";

export type GetTransferProductsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetTransferProductsQuery = { __typename: "Query" } & {
  transferProducts: Array<
    { __typename: "Product" } & Pick<Types.Product, "id" | "name" | "imageUrl">
  >;
};

export type DesignProjectsDtfArtworkFieldsFragment = { __typename: "DtfArtwork" } & Pick<
  Types.DtfArtwork,
  | "id"
  | "canRemoveBg"
  | "originalImageUrl"
  | "imageWithBackgroundUrl"
  | "imageNoBackgroundUrl"
  | "imageSliderPreviewUrl"
  | "manualEditUrl"
  | "manualEditNoTrimUrl"
  | "editImageManual"
>;

export type DesignProjectsVariantQuantityFieldsFragment = {
  __typename: "MadeDesignProjectProductVariantQuantity";
} & Pick<Types.MadeDesignProjectProductVariantQuantity, "variantId" | "quantity">;

export type DesignProjectsProductFieldsFragment = { __typename: "MadeDesignProjectProduct" } & Pick<
  Types.MadeDesignProjectProduct,
  "catalogNumber" | "compositionId"
> & {
    quantities: Array<
      { __typename: "MadeDesignProjectProductVariantQuantity" } & Pick<
        Types.MadeDesignProjectProductVariantQuantity,
        "variantId" | "quantity"
      >
    >;
  };

export type DesignProjectsPlacementFieldsFragment = {
  __typename: "MadeDesignProjectPlacement";
} & Pick<
  Types.MadeDesignProjectPlacement,
  | "id"
  | "width"
  | "height"
  | "side"
  | "position"
  | "customNeckDistances"
  | "enhanceImage"
  | "enhancementRequestNote"
  | "enhancementTier"
  | "removeBackground"
  | "editImageManual"
> & {
    dtfArtwork: { __typename: "DtfArtwork" } & Pick<
      Types.DtfArtwork,
      | "id"
      | "canRemoveBg"
      | "originalImageUrl"
      | "imageWithBackgroundUrl"
      | "imageNoBackgroundUrl"
      | "imageSliderPreviewUrl"
      | "manualEditUrl"
      | "manualEditNoTrimUrl"
      | "editImageManual"
    >;
  };

export type DesignProjectsFieldsFragment = { __typename: "MadeDesignProject" } & Pick<
  Types.MadeDesignProject,
  | "id"
  | "uuid"
  | "name"
  | "email"
  | "phoneNumber"
  | "activeCompositionId"
  | "createdAt"
  | "updatedAt"
> & {
    products: Array<
      { __typename: "MadeDesignProjectProduct" } & Pick<
        Types.MadeDesignProjectProduct,
        "catalogNumber" | "compositionId"
      > & {
          quantities: Array<
            { __typename: "MadeDesignProjectProductVariantQuantity" } & Pick<
              Types.MadeDesignProjectProductVariantQuantity,
              "variantId" | "quantity"
            >
          >;
        }
    >;
    backPlacement?: Types.Maybe<
      { __typename: "MadeDesignProjectPlacement" } & Pick<
        Types.MadeDesignProjectPlacement,
        | "id"
        | "width"
        | "height"
        | "side"
        | "position"
        | "customNeckDistances"
        | "enhanceImage"
        | "enhancementRequestNote"
        | "enhancementTier"
        | "removeBackground"
        | "editImageManual"
      > & {
          dtfArtwork: { __typename: "DtfArtwork" } & Pick<
            Types.DtfArtwork,
            | "id"
            | "canRemoveBg"
            | "originalImageUrl"
            | "imageWithBackgroundUrl"
            | "imageNoBackgroundUrl"
            | "imageSliderPreviewUrl"
            | "manualEditUrl"
            | "manualEditNoTrimUrl"
            | "editImageManual"
          >;
        }
    >;
    frontPlacement?: Types.Maybe<
      { __typename: "MadeDesignProjectPlacement" } & Pick<
        Types.MadeDesignProjectPlacement,
        | "id"
        | "width"
        | "height"
        | "side"
        | "position"
        | "customNeckDistances"
        | "enhanceImage"
        | "enhancementRequestNote"
        | "enhancementTier"
        | "removeBackground"
        | "editImageManual"
      > & {
          dtfArtwork: { __typename: "DtfArtwork" } & Pick<
            Types.DtfArtwork,
            | "id"
            | "canRemoveBg"
            | "originalImageUrl"
            | "imageWithBackgroundUrl"
            | "imageNoBackgroundUrl"
            | "imageSliderPreviewUrl"
            | "manualEditUrl"
            | "manualEditNoTrimUrl"
            | "editImageManual"
          >;
        }
    >;
  };

export type GetDesignProjectQueryVariables = Types.Exact<{
  sample: Types.Scalars["Boolean"]["input"];
  new?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  uuid?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  catalogNumber?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  activeColor?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type GetDesignProjectQuery = { __typename: "Query" } & {
  madeDesignProject?: Types.Maybe<
    { __typename: "MadeDesignProject" } & Pick<
      Types.MadeDesignProject,
      | "id"
      | "uuid"
      | "name"
      | "email"
      | "phoneNumber"
      | "activeCompositionId"
      | "createdAt"
      | "updatedAt"
    > & {
        products: Array<
          { __typename: "MadeDesignProjectProduct" } & Pick<
            Types.MadeDesignProjectProduct,
            "catalogNumber" | "compositionId"
          > & {
              quantities: Array<
                { __typename: "MadeDesignProjectProductVariantQuantity" } & Pick<
                  Types.MadeDesignProjectProductVariantQuantity,
                  "variantId" | "quantity"
                >
              >;
            }
        >;
        backPlacement?: Types.Maybe<
          { __typename: "MadeDesignProjectPlacement" } & Pick<
            Types.MadeDesignProjectPlacement,
            | "id"
            | "width"
            | "height"
            | "side"
            | "position"
            | "customNeckDistances"
            | "enhanceImage"
            | "enhancementRequestNote"
            | "enhancementTier"
            | "removeBackground"
            | "editImageManual"
          > & {
              dtfArtwork: { __typename: "DtfArtwork" } & Pick<
                Types.DtfArtwork,
                | "id"
                | "canRemoveBg"
                | "originalImageUrl"
                | "imageWithBackgroundUrl"
                | "imageNoBackgroundUrl"
                | "imageSliderPreviewUrl"
                | "manualEditUrl"
                | "manualEditNoTrimUrl"
                | "editImageManual"
              >;
            }
        >;
        frontPlacement?: Types.Maybe<
          { __typename: "MadeDesignProjectPlacement" } & Pick<
            Types.MadeDesignProjectPlacement,
            | "id"
            | "width"
            | "height"
            | "side"
            | "position"
            | "customNeckDistances"
            | "enhanceImage"
            | "enhancementRequestNote"
            | "enhancementTier"
            | "removeBackground"
            | "editImageManual"
          > & {
              dtfArtwork: { __typename: "DtfArtwork" } & Pick<
                Types.DtfArtwork,
                | "id"
                | "canRemoveBg"
                | "originalImageUrl"
                | "imageWithBackgroundUrl"
                | "imageNoBackgroundUrl"
                | "imageSliderPreviewUrl"
                | "manualEditUrl"
                | "manualEditNoTrimUrl"
                | "editImageManual"
              >;
            }
        >;
      }
  >;
};

export type MadeAddToCartMutationVariables = Types.Exact<{
  input: Types.AddMadeToCartInput;
}>;

export type MadeAddToCartMutation = { __typename: "Mutation" } & {
  addMadeToCart?: Types.Maybe<
    { __typename: "AddMadeToCartPayload" } & Pick<Types.AddMadeToCartPayload, "assemblyGroupId"> & {
        lineItems: Array<
          { __typename: "LineItemQuantity" } & Pick<
            Types.LineItemQuantity,
            "lineItemId" | "quantity"
          >
        >;
      }
  >;
};

export type LineItemArtworkDownloadLinksQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type LineItemArtworkDownloadLinksQuery = { __typename: "Query" } & {
  node?: Types.Maybe<
    { __typename: "SpreeLineItem" } & {
      artworkDownloadLinks: Array<
        { __typename: "TypedUrl" } & Pick<Types.TypedUrl, "type" | "url">
      >;
    }
  >;
};

export type LineItemBasicArtworkDownloadLinksQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type LineItemBasicArtworkDownloadLinksQuery = { __typename: "Query" } & {
  node?: Types.Maybe<
    { __typename: "SpreeLineItem" } & {
      basicArtworkDownloadLinks: Array<
        { __typename: "TypedUrl" } & Pick<Types.TypedUrl, "type" | "url">
      >;
    }
  >;
};

export const DesignProjectsVariantQuantityFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsVariantQuantityFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MadeDesignProjectProductVariantQuantity" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "variantId" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<DesignProjectsVariantQuantityFieldsFragment, unknown>;
export const DesignProjectsProductFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsProductFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MadeDesignProjectProduct" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "catalogNumber" } },
          { kind: "Field", name: { kind: "Name", value: "compositionId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "quantities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DesignProjectsVariantQuantityFields" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsVariantQuantityFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MadeDesignProjectProductVariantQuantity" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "variantId" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<DesignProjectsProductFieldsFragment, unknown>;
export const DesignProjectsDtfArtworkFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsDtfArtworkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DtfArtwork" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "canRemoveBg" } },
          { kind: "Field", name: { kind: "Name", value: "originalImageUrl" } },
          { kind: "Field", name: { kind: "Name", value: "imageWithBackgroundUrl" } },
          { kind: "Field", name: { kind: "Name", value: "imageNoBackgroundUrl" } },
          { kind: "Field", name: { kind: "Name", value: "imageSliderPreviewUrl" } },
          { kind: "Field", name: { kind: "Name", value: "manualEditUrl" } },
          { kind: "Field", name: { kind: "Name", value: "manualEditNoTrimUrl" } },
          { kind: "Field", name: { kind: "Name", value: "editImageManual" } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<DesignProjectsDtfArtworkFieldsFragment, unknown>;
export const DesignProjectsPlacementFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsPlacementFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MadeDesignProjectPlacement" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
          { kind: "Field", name: { kind: "Name", value: "side" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "customNeckDistances" } },
          { kind: "Field", name: { kind: "Name", value: "enhanceImage" } },
          { kind: "Field", name: { kind: "Name", value: "enhancementRequestNote" } },
          { kind: "Field", name: { kind: "Name", value: "enhancementTier" } },
          { kind: "Field", name: { kind: "Name", value: "removeBackground" } },
          { kind: "Field", name: { kind: "Name", value: "editImageManual" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dtfArtwork" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DesignProjectsDtfArtworkFields" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsDtfArtworkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DtfArtwork" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "canRemoveBg" } },
          { kind: "Field", name: { kind: "Name", value: "originalImageUrl" } },
          { kind: "Field", name: { kind: "Name", value: "imageWithBackgroundUrl" } },
          { kind: "Field", name: { kind: "Name", value: "imageNoBackgroundUrl" } },
          { kind: "Field", name: { kind: "Name", value: "imageSliderPreviewUrl" } },
          { kind: "Field", name: { kind: "Name", value: "manualEditUrl" } },
          { kind: "Field", name: { kind: "Name", value: "manualEditNoTrimUrl" } },
          { kind: "Field", name: { kind: "Name", value: "editImageManual" } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<DesignProjectsPlacementFieldsFragment, unknown>;
export const DesignProjectsFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MadeDesignProject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "activeCompositionId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "products" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DesignProjectsProductFields" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "backPlacement" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DesignProjectsPlacementFields" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "frontPlacement" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DesignProjectsPlacementFields" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsDtfArtworkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DtfArtwork" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "canRemoveBg" } },
          { kind: "Field", name: { kind: "Name", value: "originalImageUrl" } },
          { kind: "Field", name: { kind: "Name", value: "imageWithBackgroundUrl" } },
          { kind: "Field", name: { kind: "Name", value: "imageNoBackgroundUrl" } },
          { kind: "Field", name: { kind: "Name", value: "imageSliderPreviewUrl" } },
          { kind: "Field", name: { kind: "Name", value: "manualEditUrl" } },
          { kind: "Field", name: { kind: "Name", value: "manualEditNoTrimUrl" } },
          { kind: "Field", name: { kind: "Name", value: "editImageManual" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsVariantQuantityFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MadeDesignProjectProductVariantQuantity" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "variantId" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsProductFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MadeDesignProjectProduct" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "catalogNumber" } },
          { kind: "Field", name: { kind: "Name", value: "compositionId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "quantities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DesignProjectsVariantQuantityFields" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsPlacementFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MadeDesignProjectPlacement" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
          { kind: "Field", name: { kind: "Name", value: "side" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "customNeckDistances" } },
          { kind: "Field", name: { kind: "Name", value: "enhanceImage" } },
          { kind: "Field", name: { kind: "Name", value: "enhancementRequestNote" } },
          { kind: "Field", name: { kind: "Name", value: "enhancementTier" } },
          { kind: "Field", name: { kind: "Name", value: "removeBackground" } },
          { kind: "Field", name: { kind: "Name", value: "editImageManual" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dtfArtwork" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DesignProjectsDtfArtworkFields" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<DesignProjectsFieldsFragment, unknown>;
export const GetTransferProductsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTransferProducts" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "transferProducts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "imageUrl" } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetTransferProductsQuery, GetTransferProductsQueryVariables>;
export const GetDesignProjectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDesignProject" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sample" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } }
          }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "new" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "catalogNumber" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "activeColor" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "madeDesignProject" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sample" },
                value: { kind: "Variable", name: { kind: "Name", value: "sample" } }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "new" },
                value: { kind: "Variable", name: { kind: "Name", value: "new" } }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: { kind: "Variable", name: { kind: "Name", value: "uuid" } }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "catalogNumber" },
                value: { kind: "Variable", name: { kind: "Name", value: "catalogNumber" } }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "activeColor" },
                value: { kind: "Variable", name: { kind: "Name", value: "activeColor" } }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "DesignProjectsFields" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsDtfArtworkFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DtfArtwork" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "canRemoveBg" } },
          { kind: "Field", name: { kind: "Name", value: "originalImageUrl" } },
          { kind: "Field", name: { kind: "Name", value: "imageWithBackgroundUrl" } },
          { kind: "Field", name: { kind: "Name", value: "imageNoBackgroundUrl" } },
          { kind: "Field", name: { kind: "Name", value: "imageSliderPreviewUrl" } },
          { kind: "Field", name: { kind: "Name", value: "manualEditUrl" } },
          { kind: "Field", name: { kind: "Name", value: "manualEditNoTrimUrl" } },
          { kind: "Field", name: { kind: "Name", value: "editImageManual" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsVariantQuantityFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MadeDesignProjectProductVariantQuantity" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "variantId" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsProductFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MadeDesignProjectProduct" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "catalogNumber" } },
          { kind: "Field", name: { kind: "Name", value: "compositionId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "quantities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DesignProjectsVariantQuantityFields" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsPlacementFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MadeDesignProjectPlacement" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
          { kind: "Field", name: { kind: "Name", value: "side" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "customNeckDistances" } },
          { kind: "Field", name: { kind: "Name", value: "enhanceImage" } },
          { kind: "Field", name: { kind: "Name", value: "enhancementRequestNote" } },
          { kind: "Field", name: { kind: "Name", value: "enhancementTier" } },
          { kind: "Field", name: { kind: "Name", value: "removeBackground" } },
          { kind: "Field", name: { kind: "Name", value: "editImageManual" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dtfArtwork" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DesignProjectsDtfArtworkFields" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DesignProjectsFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MadeDesignProject" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "activeCompositionId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "products" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DesignProjectsProductFields" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "backPlacement" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DesignProjectsPlacementFields" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "frontPlacement" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DesignProjectsPlacementFields" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetDesignProjectQuery, GetDesignProjectQueryVariables>;
export const MadeAddToCartDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MadeAddToCart" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "AddMadeToCartInput" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addMadeToCart" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lineItems" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "lineItemId" } },
                      { kind: "Field", name: { kind: "Name", value: "quantity" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "assemblyGroupId" } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<MadeAddToCartMutation, MadeAddToCartMutationVariables>;
export const LineItemArtworkDownloadLinksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LineItemArtworkDownloadLinks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "node" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SpreeLineItem" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "artworkDownloadLinks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  LineItemArtworkDownloadLinksQuery,
  LineItemArtworkDownloadLinksQueryVariables
>;
export const LineItemBasicArtworkDownloadLinksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LineItemBasicArtworkDownloadLinks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "node" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SpreeLineItem" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "basicArtworkDownloadLinks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  LineItemBasicArtworkDownloadLinksQuery,
  LineItemBasicArtworkDownloadLinksQueryVariables
>;
